// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"38d93dab","568":"ffd69e77","791":"7cdf403d","855":"ab2fe03f","898":"057cc714","923":"25bde3f1"}[chunkId] + ".chunk.css";
};